import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

import { PopoverController } from '@ionic/angular';
import { Aula, Edificio, Geo } from 'src/app/models/impegno-docente.models';
declare var google: any;

@Component({
    selector: 'app-info-popover',
    templateUrl: './info-popover.component.html',
    styleUrls: ['./info-popover.component.scss'],
    standalone: false
})
export class InfoPopoverComponent implements OnInit {
  @ViewChild('mapCanvas', { static: true }) mapElement: ElementRef;

  @Input() datas;

  map: any;
  bounds: any;
  aula: Aula;
  edificio: Edificio;
  notePubblicheImpegno: Aula;
  displayMap = false;

  constructor(
    public popoverController: PopoverController
    ) {
  }

  ngOnInit() {

    // popover informazioni aula ed edificio
    if (this.datas && this.datas.aula) {
      this.aula =  this.datas.aula;
      this.edificio = this.datas.edificio;
    }

    // popover notePubbliche Impegno
    if (this.datas && this.datas.notePubbliche) {
      this.notePubblicheImpegno =  this.datas.notePubbliche;
    }
  }

  showMapEdificio() {
      setTimeout(() => {
        if (this.displayMap) {
          if (this.edificio && this.edificio.geo) {
            this.showMap(this.edificio.geo);
          }
        }
      }, 500);
  }


  showMap(geo: Geo) {
    console.log( 'geo  ', geo );
    // console.log( 'this.mapElement  ', this.mapElement );
    const mapEle = this.mapElement.nativeElement;
    this.map = new google.maps.Map(mapEle, {
      center: geo,
      zoom: 16
    });
    this.bounds = new google.maps.LatLngBounds();
    google.maps.event.addListenerOnce(this.map, 'idle', () => {
      console.log( 'map showing ...  ' );
      mapEle.classList.add('show-map');
    });
  }

}
